import { useDispatch } from "react-redux";
import { userSignedOut } from "redux-oidc";
import { Button } from "@mui/material";
import { userManager } from "../../../core/services/user.manager.service";

/**
 * Composant permettant de déclencher une déconnexion.
 * (Version temporaire utilisée pour faire des tests, à terme on se branchera à la barre de connexion).
 */
export const SignoutPanel = () => {
	const dispatch = useDispatch();

	const signoutClick = async () => {
		dispatch(userSignedOut());
		await userManager.removeUser();
		window.location.href = window.config.addresseDeconnexionPortail.replace(
			"{redirect_target}",
			encodeURIComponent(window.location.href)
		);
	};

	return <Button onClick={signoutClick}>Déconnexion</Button>;
};
